define('settings/settings',['require','exports','module','knockout','durandal/app','jquery','api-access'],function (require, exports, module) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var $ = require('jquery');
    var userApi = require('api-access').user;

    function settings() {
        var self = this;
        var enablePresenterSwapPopover = false;

        self.activate = function (activationData) {
            enablePresenterSwapPopover = activationData;
            self.attendeesCard = ko.observable();
            self.logoCard = ko.observable();
            self.setSaleCard = ko.observable();
            self.recordingsCard = ko.observable();

            return userApi.settings().then(function (userSettings) {
                if (!userSettings.nativeEndpointDisabled) {
                    self.attendeesCard('settings/lib/attendees/attendees');
                    self.logoCard('settings/lib/logo/logo');
                }
                if (userSettings.setSaleProvisioned) {
                    /*
                    * setSaleEnabled flag is based on user preferences (defaultValue: false  (in settings pane) )
                    * setSaleEntitled  flag is based on account  preferences (read-only value is sent by MS)
                    * setSaleProvisioned  flag is based on licenses preferences (read-only value is sent by MS)
                    */
                    self.setSaleCard('settings/lib/setSale-analytics/set-sale-analytics');
                }
                if (userSettings.cbrProvisioned && userSettings.cbrEnabled && userSettings.transcriptsProvisioned) {
                    self.recordingsCard('settings/lib/recordings/recordings');
                }
            });
        };

        self.deactivate = function () {
            /*  If the country selection dialog is opened and the user navigates back
            or to another page, then cancel needs to be invoked*/
            var countryCancelButton = $('#country-cancel');
            if (countryCancelButton.length) {
                countryCancelButton[0].click();
            }
        };

        self.compositionComplete = function () {
            if (enablePresenterSwapPopover) {
                $('.presenter-swap-wrapper .popover-inverse').css('display', 'block');
                app.trigger('attendees:enablePresenterMode');
            }
        };
    }

    module.exports = settings;
});

